import { scrollTo, ScrollToCustomOptions } from 'scroll-js'

type ScrollTarget = Window | HTMLElement

const defaultScroller = (): ScrollTarget => {
  if (typeof window !== 'undefined') return window
  return {} as ScrollTarget
}

let targetScroller: ScrollTarget = defaultScroller()

export const setAppScroller = (newTarget: ScrollTarget) => {
  targetScroller = newTarget
}

export const getAppScroller = () => targetScroller

export const appScroll = async (scrollToOptions: ScrollToCustomOptions) =>
  scrollTo(targetScroller, scrollToOptions)

/* we use scroll-js' scrollTo directly in some cases */
export { scrollTo }
